import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/components/skeletonLoaders/constants';

export const AvatarSkeleton = () => (
  <ContentLoader height={32} viewBox="0 0 32 32" {...DEFAULT_SETTINGS}>
    <circle cx="16" cy="16" r="16" />
  </ContentLoader>
);
